module.exports = __webpack_public_path__ + "static/media/titc-hero-new.ab6382bb.png";